// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"c-CurrentLocationButton__wrapper","label":"c-CurrentLocationButton__label"};


//////////////////
// WEBPACK FOOTER
// ./src/components/presentational/CurrentLocationButton/CurrentLocationButton.scss
// module id = 879
// module chunks = 0